import {
  Member,
  Benefit,
  Question
} from '@td/membersupport';
import {
  maskedInfo,
  maskData
} from '../../Utils';
import { get } from 'lodash';

function isHouseAccount(restrictions) {
  return !(restrictions.hasLimitedPhiAccess || restrictions.hasLimitedPiAccess);
}

const fetchSecurityQuestions = (securityQuestions) => {
  let membersQuestionsList = [];
  _.forIn(securityQuestions, (response, k=1) => {
    let q = Question({
      questionId: k++,
      securityQuestion: response.securityQuestion,
      securityResponse: maskedInfo,
    })

    membersQuestionsList.push(q);
  });

  return membersQuestionsList;
}

function restrictedMember(member, restrictions) {
  const m = Member({
    memberId:       get(member, 'memberId'),
    defaultProfile: {
      benefits: (get(member, 'benefits') || []).map(benefit => Benefit({
        mrnId: get(benefit, 'mrnId'),
        sponsor:           get(benefit, 'group.name'),
        canAccessOneapp:   get(benefit, 'group.oneAppFlag'),
        classification:    benefit.isPrimary ? 'Primary' : 'Dependent',
        isActive:          get(benefit, 'isActive'),
        healthPlanId:      maskedInfo,
        coverageStartDate: get(benefit, 'coverageStartDate'),
        coverageEndDate:   get(benefit, 'coverageEndDate'),
        products:          [maskedInfo]
      })),
      lastMhdUpdate:     maskData(get(member, 'lastMhdUpdate', 'No MHD'), restrictions.hasLimitedPhiAccess),
      securityQuestions: fetchSecurityQuestions(get(member, 'person.securityQuestions', [])),
    },
    firstName:        isHouseAccount(restrictions) ? maskedInfo : get(member, 'firstName'),
    lastName:         isHouseAccount(restrictions) ? maskedInfo : get(member, 'lastName'),
    dob:              maskedInfo,
    email:            maskedInfo,
    gender:           maskedInfo,
    phoneNumber:      maskedInfo,
    username:         maskedInfo,
    vip:              get(member, 'vipFlag'),
    street:           maskedInfo,
    residentState:    maskedInfo,
    city:             maskedInfo,
    zipCode:          maskedInfo,
    registered:       true,
    canRegister:      member.status !== 'MEMBERSTATUS_ACT',
    canceled:         member.status === 'MEMBERSTATUS_CAN',
    suspended:         member.status === 'MEMBERSTATUS_SUS',
    canResetPassword: restrictions.canResetPassword,
    canImpersonate:   restrictions.canImpersonate,
    userType:         get(member, 'userType')
  });

  return m;
}

export default restrictedMember;
